import { inject, Injectable } from '@angular/core';
import { fromAuth } from '@iot-platform/auth';
import { AbstractUserPreferencesFavoriteFilterEngineService } from '@iot-platform/iot-platform-ui';
import { UserAccount, UserPreferences } from '@iot-platform/models/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { PreferencesActions } from '../state/actions';
import * as fromUserPreferences from '../state/reducers';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesFavoriteFilterEngineService extends AbstractUserPreferencesFavoriteFilterEngineService {
  protected readonly store: Store = inject(Store);

  getAccount$(): Observable<UserAccount> {
    return this.store.select(fromAuth.selectAccount);
  }

  getUserPreferences$(): Observable<UserPreferences> {
    return this.store.select(fromUserPreferences.getPreferences);
  }

  saveUserPreferences(preferences: UserPreferences): void {
    this.store.dispatch(PreferencesActions.saveUserPreferences({ preferences }));
  }
}
